// chi's nsfw writeup is a spoken sentence, never a tag dump

export function hasProseCaption(text: string): boolean {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (clean.length < 24) return false;
  if (/^(pose|fetish|tags|body|expression|context)\s*[:]/i.test(clean)) return false;
  const words = clean.split(" ").filter(Boolean);
  if (words.length < 6) return false;
  const tagged = words.filter((word) => word.includes("_") || /rating:[sqe]/i.test(word)).length;
  return tagged <= words.length / 2;
}

export function chiWrote(entry: { caption?: string }): boolean {
  return hasProseCaption(entry.caption || "");
}

export function glueSeen(parts: { pose?: string; fetish?: string; expression?: string; body?: string; context?: string }): string {
  return [parts.pose, parts.fetish, parts.expression, parts.body, parts.context]
    .map((part) => String(part || "").replace(/\s+/g, " ").trim())
    .filter(Boolean)
    .join(", ");
}

export function chiCaption(row: { caption?: string; pose?: string; fetish?: string; expression?: string; body?: string; context?: string }, max = 400): string {
  const prose = String(row.caption || "").replace(/\s+/g, " ").trim().slice(0, max);
  if (hasProseCaption(prose)) return prose;
  const glued = glueSeen(row).slice(0, max);
  if (hasProseCaption(glued)) return glued;
  return "";
}
